import { frontendURL } from '../../../helper/URLHelper';
import TicketsIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'tickets_dashboard_index',
    meta: {
      permissions: ['administrator', 'agent', 'ticket_manage'],
      module: 'tickets',
    },
    component: TicketsIndex,
  },
  {
    path: frontendURL('accounts/:accountId/tickets/:ticketId'),
    name: 'tickets_dashboard_details',
    meta: {
      permissions: ['administrator', 'agent', 'ticket_manage'],
      module: 'tickets',
    },
    component: () => import('./TicketDetails.vue'),
  },
];
